/**
 * @description header4 button menu
 * @author wangfupeng
 */

import HeaderButtonMenuBase from './HeaderButtonMenuBase'

class Header4ButtonMenu extends HeaderButtonMenuBase {
  title = 'H4'

  type = 'header4'
}

export default Header4ButtonMenu
